import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50"></i>
                </div>
                <span className="text-xl font-bold font-heading text-background-50 whitespace-nowrap">成全影院</span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                成全影院致力于提供高清画质流畅播放体验，无广告干扰，免费在线观看电影电视剧全集。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading whitespace-nowrap">
                <a href="#footer-nav" className="text-background-50 no-underline">快速导航</a>
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/dongzuo" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">动作片</Link>
                <Link to="/category/xiju" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧片</Link>
                <Link to="/category/kehuan" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">科幻片</Link>
                <Link to="/category/aiqing" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">爱情片</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading whitespace-nowrap">
                <a href="#footer-links" className="text-background-50 no-underline">更多链接</a>
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/donghua" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">动画片</Link>
                <Link to="/category/kongbu" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">恐怖片</Link>
                <Link to="/category/xuanyi" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">悬疑片</Link>
                <Link to="/category/juqing" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">剧情片</Link>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading whitespace-nowrap">联系方式</h4>
              <div className="flex flex-col gap-2 text-sm text-secondary-300">
                <span className="whitespace-nowrap"><i className="ri-mail-line mr-2"></i>contact@chengquan.tv</span>
                <span className="whitespace-nowrap"><i className="ri-phone-line mr-2"></i>400-888-6666</span>
                <span className="whitespace-nowrap"><i className="ri-map-pin-line mr-2"></i>北京市朝阳区影视大道88号</span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500 whitespace-nowrap">
              &copy; {new Date().getFullYear()} 成全影院 ChengQuan.tv - 保留所有权利
            </p>
            <div className="flex items-center gap-4 text-xs text-secondary-500">
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}